import React from 'react';
import {SmallUnderline} from "../../styles/components/SmallUnderline";
import {Button} from "../button/Button";
import { Row, Col, Container, Collapse } from 'reactstrap';
import {ContactUsForm} from "../../forms/ContactUsForm";
import { connect } from 'react-redux';

class ContactUsHiddenFormSectionContainer extends React.Component {

  constructor(props) {
    super(props);

    this.showForm = this.showForm.bind(this);

    this.state = {
      showForm: false,
      tel: this.props.data && this.props.data.acf && this.props.data.acf.obx_contact_us_section_tel,
      email: this.props.data && this.props.data.acf && this.props.data.acf.obx_contact_us_email
    };
  }

  showForm() {
    this.setState({ showForm: true });
  }

  render(){
    return (
      <div className="contact-us-container">
        <Container>
          <Row className="justify-content-center">
            <Col xs="12" md="12" className="text-center contact-us-text-container">
              <SmallUnderline align="center">
                <h1>Contact Us</h1>
              </SmallUnderline>
              <p className="contact-us-body">
                Our professional team will assist you in finding the right solution, and discuss further on our tailored lighting solutions."
              </p>
              <ul className="contact-us-info pb-3">
                <li>
                  <span className="obelux-icons icon-contact-us" aria-hidden="true">&#xE051;</span>
                  <a href={ "tel:" + this.state.tel }>&nbsp;{ this.state.tel }</a></li>
                <li>
                  <span className="obelux-icons icon-contact-us" aria-hidden="true">&#xE005;</span>
                  <a href={ "mailto:" + this.state.email }>&nbsp;{ this.state.email }</a>
                </li>
              </ul>
              {
                !this.state.showForm &&
                <Button size={"sm"} onClick={this.showForm}>
                  <span className="obelux-icons" aria-hidden="true">&#xE050;</span> Contact Us</Button>
              }
            </Col>
          </Row>
          <Row>
            <Collapse isOpen={this.state.showForm} className={"pb-5"} style={{ width: "100%" }}>
              <ContactUsForm/>
            </Collapse>
          </Row>
        </Container>
      </div>
    );
  }
}


export const ContactUsHiddenFormSection = connect(
  state => ({
    data: state.resolve.data.contact_us_section
  })
)(ContactUsHiddenFormSectionContainer);



// WEBPACK FOOTER //
// ./src/components/contact-us/ContactUsHiddenFormSection.js